import React, {Fragment, FC} from 'react';
import {connect} from 'react-redux';
import WrapperPreloader from "../../components/WrapperPreloader";
import NavBar from "../../components/NavBar";
import {setActivePage} from "../../modules/System";
import Main from '../../components/Main/index'
import {setCurrentTab} from "../../modules/Main";

interface IMainPage {
    isLoading: boolean,
    isUserAuth: boolean,
    activePage: string,
    setActivePage: any,
    currentTab: number,
    setCurrentTab: any
}

const  MainPage:FC<IMainPage> = ({
                                     isLoading,
                                     activePage,
                                     setActivePage,
                                     currentTab,
                                     setCurrentTab}) => {

        return (
            <WrapperPreloader isLoading={isLoading}>
                <Fragment>
                    <Main
                        currentTab={currentTab}
                        setCurrentTab={setCurrentTab}
                    />
                    <NavBar
                        setActivePage={setActivePage}
                        activePage={activePage}
                    />
                </Fragment>
            </WrapperPreloader>
        )
};

const mapStateToProps = (state: any) => ({
    isLoading: state.main.isLoading,
    isUserAuth: state.system.isUserAuth,
    activePage: state.system.activePage,
    currentTab: state.main.currentTab,
});

const mapDispatchToProps = (dispatch: any) => ({
    setActivePage: (page: string) => dispatch((setActivePage(page))),
    setCurrentTab: (id: number) => dispatch((setCurrentTab(id))),
});

export default connect(
    mapStateToProps,
    mapDispatchToProps,
)(MainPage);
